import httpClient from '@/http-client'

export const getTotal = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/total-cards', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getCashCollectionByCashier = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/cash-collection-by-cashiers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTop10FastProductSold = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/top10-fast-product-solds', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSaleByProductGroup = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/sale-by-product-groups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSalePerformanceByHour = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/sale-performance-by-hours', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getBranch = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/branches', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPromotionStatistic = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/promotion-statistics', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getTop10SlowProductSold = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/top10-slow-product-solds', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getQuotationStatistic = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/quotation-statistics', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSaleContractStatistic = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/sale-contract-statistics', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCustomerInvoiceStatistic = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/customer-invoice-statistics', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getVendorInvoiceStatistic = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/vendor-invoice-statistics', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getNearlyExpired = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/nearly-expired-products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getReOrderProduct = (Options = {}) => {
  return httpClient
    .get('/api/v1/dashboard/widget/re-order-products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getTotal,
  getCashCollectionByCashier,
  getTop10FastProductSold,
  getBranch,
  getSaleByProductGroup,
  getSalePerformanceByHour,
  getPromotionStatistic,
  getTop10SlowProductSold,
  getQuotationStatistic,
  getSaleContractStatistic,
  getCustomerInvoiceStatistic,
  getVendorInvoiceStatistic,
  getNearlyExpired,
  getReOrderProduct
}
